// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_List from "@rescript/runtime/lib/es6/Stdlib_List.js";
import * as Stylex from "@stylexjs/stylex";
import * as Notifier__Context from "./Notifier__Context.res.js";
import * as Notifier__Reducer from "./Notifier__Reducer.res.js";
import * as JsxRuntime from "react/jsx-runtime";
let autoClearRef = {
  contents: false
};
function createContext() {
  let match = React.useReducer(Notifier__Reducer.reducer, Notifier__Reducer.initialState);
  let dispatch = match[1];
  let url = Navigation.useUrl();
  React.useEffect(() => {
    if (autoClearRef.contents) {
      dispatch("ClearRequested");
    }
  }, [url.pathname]);
  return [match[0], dispatch];
}
function add(dispatch, action, resetOpt, details, param) {
  let reset = resetOpt !== undefined ? resetOpt : false;
  let node;
  switch (action.TAG) {
    case "Success":
      node = {
        kind: "success",
        message: action._0,
        details: details,
        reset: reset
      };
      break;
    case "Error":
      node = {
        kind: "error",
        message: action._0,
        details: details,
        reset: reset
      };
      break;
    case "Warning":
      node = {
        kind: "warning",
        message: action._0,
        details: details,
        reset: reset
      };
      break;
  }
  dispatch({
    TAG: "AddRequested",
    _0: node
  });
}
function use(clearPolicyOpt, param) {
  let clearPolicy = clearPolicyOpt !== undefined ? clearPolicyOpt : "ClearOnHistoryChanges";
  let match = Notifier__Context.Context.use();
  let dispatch = match[1];
  autoClearRef.contents = clearPolicy === "ClearOnHistoryChanges";
  let make = raw => ({
    id: raw.id,
    content: raw.content,
    onClose: () => dispatch({
      TAG: "RemoveRequested",
      _0: raw.id
    })
  });
  return {
    get: Stdlib_List.map(match[0], make),
    add: (action, details, param) => add(dispatch, action, undefined, details, undefined),
    reset: (action, details, param) => add(dispatch, action, true, details, undefined),
    clear: () => dispatch("ClearRequested")
  };
}
function Notifier$Banner(props) {
  let newrecord = {
    ...{
      style: {
        width: "100%"
      }
    }
  };
  return JsxRuntime.jsx("div", (newrecord.children = Stdlib_List.toArray(Stdlib_List.map(props.notifier.get, param => {
    let content = param.content;
    let match = content.kind;
    let textStatus = match === "warning" ? {
      TAG: "Warning",
      _0: content.message
    } : match === "success" ? {
      TAG: "Success",
      _0: content.message
    } : {
      TAG: "Danger",
      _0: content.message
    };
    return JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Banner.make, {
        textStatus: textStatus,
        details: content.details,
        onRequestClose: param.onClose
      }, param.id),
      spaceTop: "medium"
    });
  })), newrecord));
}
let make = React.memo(Notifier$Banner, (oldProps, newProps) => oldProps.notifier.get === newProps.notifier.get);
let Banner$1 = {
  make: make
};
let Context = Notifier__Context.Context;
let Provider = Notifier__Context.Provider;
let Types;
export { Context, Provider, Types, autoClearRef, createContext, add, use, Banner$1 as Banner };
/* make Not a pure module */